module.exports = __webpack_public_path__ + "static/Portrait-of-Sigurd-min-bdfe4da0a6c6028743c3beb90941d746.jpg";